<template>
  <div class="header">
    <span class="back" @click="back">{{ $t("index.back") }}</span>
  </div>
  <div class="inner">
    <div class="menu">
      <a-menu
        v-model:selectedKeys="current"
        :items="items"
        mode="inline"
        @click="handleClick()"
        v-model:openKeys="openKeys"
        id="folderMenu"
      />
    </div>
    <div class="tab">
      <a-form
        ref="searchFormRef"
        name="advanced_search"
        class="ant-advanced-search-form topSearch"
        :model="searchFormState"
      >
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item name="searchKey" :label="$t('home.label')" label="订单编号">
              <a-input
                v-model:value="searchFormState.searchKey"
                :placeholder="$t('home.labelin')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-button type="primary" @click="loadData()">
              <template #icon>
                <SearchOutlined />
              </template>
              {{ $t("home.search") }}
            </a-button>
            <a-button class="buttom-left" @click="reset">
              <template #icon><redo-outlined /></template>
              {{ $t("home.reset") }}
            </a-button>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        :columns="columns"
        :dataSource="dataSource"
        :row-key="(record) => record.Id"
        :loading="loading"
        style="border-radius: 0px"
        :bordered="false"
      >
        <template #operator class="table-operator"> </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'Title'">
            <a @click="article(record)">{{ record.Title }}</a>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <a @click="article(record)">{{ $t("index.look") }}</a>
          </template>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script setup>
import { h, ref, onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";
import { message } from "ant-design-vue";
import { FolderOutlined, FileOutlined } from "@ant-design/icons-vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

let route = useRoute();
let router = useRouter();

const articleId = ref(route.params.id);
localStorage.setItem("folder", route.params.id);

const current = ref([]);
const items = ref([]);
const openKeys = ref([]);

const directory = ref([]);

// 定义tableDOM
const table = ref(null);
const dataSource = ref([]);
const loading = ref(false);
let searchFormState = reactive({});
const searchFormRef = ref();

const columns = [
  {
    title: t("index.knowledgetb1"),
    dataIndex: "Title",
  },
  {
    title: t("index.knowledgetb2"),
    dataIndex: "Lable",
  },
  {
    title: t("index.knowledgetb6"),
    dataIndex: "Series",
  },
  {
    title: t("index.knowledgetb3"),
    dataIndex: "Language",
  },
  {
    title: t("index.knowledgetb4"),
    dataIndex: "CreateTime",
  },
  {
    title: t("index.knowledgetb5"),
    dataIndex: "action",
    align: "center",
  },
];

const lang = localStorage.getItem("lang");

let languageArr = [
  {
    value: "Chinese",
    label: "中文",
  },
  {
    value: "ChineseTraditional",
    label: "繁体中文",
  },
  {
    value: "English",
    label: "英语",
  },
  {
    value: "Russian",
    label: "俄语",
  },
  {
    value: "Japanese",
    label: "日语",
  },
  {
    value: "Korean",
    label: "韩语",
  },
  {
    value: "German",
    label: "德语",
  },
  {
    value: "French",
    label: "法语",
  },
  {
    value: "Italia",
    label: "意大利语",
  },
  {
    value: "Spanish",
    label: "西班牙语",
  },
  {
    value: "Portuguese",
    label: "葡萄牙语",
  },
  {
    value: "Arabic",
    label: "阿拉伯语",
  },
  {
    value: "Turkish",
    label: "土耳其语",
  },
  {
    value: "Thai",
    label: "泰语",
  },
  {
    value: "Vietnamese",
    label: "越南语",
  },
  {
    value: "Persian",
    label: "波斯语",
  },
  {
    value: "Indonesia",
    label: "印度尼西亚语",
  },
  {
    value: "Hungarian",
    label: "匈牙利语",
  },
  {
    value: "Czech",
    label: "捷克语",
  },
  {
    value: "Hebrew",
    label: "希伯来语",
  },
];

function findIndexByValue(targetValue) {
  for (let i = 0; i < languageArr.length; i++) {
    if (languageArr[i].value === targetValue.value) {
      return i; // 返回找到的索引
    }
  }
  return -1; // 如果没有找到，返回-1
}

function copyTransFun(arr) {
  arr.forEach((item) => {
    if (item.id) {
      item.key = item.id;
    }
    if (item.name) {
      item.label = item.name;
    }
    if (item.children && item.children.length) {
      item.icon = () => h(FolderOutlined);
      copyTransFun(item.children);
    } else {
      delete item.children;
      item.icon = () => h(FileOutlined);
      if (current.value.length == 0) {
        current.value.push(item.key);
        openKeys.value.push(item.parentId);
      }
    }
  });
}

axios
  .post("api/KnowledgeClassify/GetJstreeDataAllowAnonymous")
  .then((response) => {
    if (response.data.code != 200) {
      message.error(response.data.info);
    } else {
      if (response.data.ReturnData[0].name == "根目录") {
        directory.value = response.data.ReturnData[0].children;
      }
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    if (directory.value.length > 0) {
      directory.value.forEach((item) => {
        if (item.id == articleId.value) {
          /* document.title = item.name; */
          if (item.children.length > 0) {
            let res = item.children;
            if (
              res[0].name == "中文" ||
              res[0].name == "英文" ||
              res[0].name == "English"
            ) {
              if (lang == "zh") {
                res.forEach((data) => {
                  if (data.name == "中文") {
                    copyTransFun(data.children);
                    items.value = data.children;
                    filterData(current.value[0]);
                  }
                });
              } else {
                res.forEach((data) => {
                  if (data.name == "英文" || data.name == "English") {
                    copyTransFun(data.children);
                    items.value = data.children;
                    filterData(current.value[0]);
                  }
                });
              }
            } else {
              copyTransFun(res);
              items.value = res;
              filterData(current.value[0]);
            }
          }
        }
      });
    }
  });

const article = (record) => {
  const routeUrl = router.resolve({
    name: "article",
    params: {
      id: record.Id,
      parentId: record.NodeId,
    },
  });
  window.open(routeUrl.href, "_blank");
};

const handleClick = (e) => {
  setTimeout(function () {
    filterData(current.value[0]);
  }, 0);
};

function loadData() {
  let newStr = searchFormState.searchKey;
  if (searchFormState.searchKey) {
    loading.value = true;
    newStr = searchFormState.searchKey.replace(/\s+/g, "");
    axios
      .post("api/KnowledgeClassify/GetContentsAllowAnonymous", {
        Id: "",
        NodeId: "",
        Title: "",
        Lable: newStr,
      })
      .then((response) => {
        if (response.data.info != 200 && response.data.ReturnData != "暂无数据") {
          dataSource.value = response.data.ReturnData;
        } else if (response.data.ReturnData == "暂无数据") {
          dataSource.value = [];
        } else {
          message.error(response.data.info);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        loading.value = false;
      });
  }
}

function filterData(pararms) {
  loading.value = true;
  axios
    .post("api/KnowledgeClassify/GetContentsAllowAnonymous", {
      Id: "",
      NodeId: pararms,
      Title: "",
      Lable: "",
      Series: "", //localStorage.getItem("series"),
    })
    .then((response) => {
      if (response.data.info != 200 && response.data.ReturnData != "暂无数据") {
        dataSource.value = response.data.ReturnData;
      } else if (response.data.ReturnData == "暂无数据") {
        dataSource.value = [];
      } else {
        message.error(response.data.info);
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      loading.value = false;
    });
}

const reset = () => {
  searchFormRef.value.resetFields();
};

let isVisitor = localStorage.getItem("isVisitor");

const back = () => {
  if (isVisitor == "false") {
    router.push(`/index/knowledge`);
  } else {
    router.push(`/visitor/knowledge`);
  }
};
</script>

<style scoped>
.menu {
  width: 20%;
  height: 100%;
}
.header {
  height: 50px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #e6e6e6;
  background: rgba(255, 255, 255, 0.24);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  z-index: 999;
  padding-left: 50px;
}
.inner {
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  padding: 0px 2% 0px 0px;
}
.back {
  height: 50px;
  line-height: 50px;
  color: #0099ff;
  margin-right: 80px;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}
.tab {
  width: 78%;
}
a {
  color: #1890ff;
}
.topSearch {
  margin: 30px 0px 0px 0px;
}
.buttom-left {
  margin-left: 20px;
}
</style>
